import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, dettaglioErrore } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errore, setErrore] = useState("");
  const [caricamento, setCaricamento] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const accedi = async (e) => {
    e.preventDefault();
    setErrore("");
    setCaricamento(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      toast.success(`Bentornato, ${data.nome}!`);
      navigate("/admin");
    } catch (err) {
      setErrore(dettaglioErrore(err));
    } finally {
      setCaricamento(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-slate-700 bg-obsidian/60 px-4 py-3.5 text-sm text-white placeholder:text-slate-500 outline-none transition-colors focus:border-amber-500";

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-obsidian px-5"
      data-testid="admin-login-page"
    >
      <div className="glass-panel w-full max-w-md rounded-2xl p-8 md:p-10">
        <div className="mb-8 flex justify-center">
          <Link to="/" aria-label="Torna alla home">
            <Logo />
          </Link>
        </div>
        <h1 className="text-center font-display text-2xl font-bold text-white">Area riservata</h1>
        <p className="mt-2 text-center text-sm text-slate-400">
          Accedi alla dashboard operativa di SOS Riparazioni 24.
        </p>
        <form onSubmit={accedi} className="mt-8 space-y-4">
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block text-xs font-medium text-slate-400">
              Email
            </label>
            <input
              id="admin-email"
              data-testid="admin-login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@sosriparazioni24.it"
              className={inputCls}
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block text-xs font-medium text-slate-400">
              Password
            </label>
            <input
              id="admin-password"
              data-testid="admin-login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className={inputCls}
            />
          </div>
          {errore && (
            <p data-testid="admin-login-error" className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400">
              {errore}
            </p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit-btn"
            disabled={caricamento}
            className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-amber-500 py-3.5 text-sm font-bold text-obsidian transition-colors hover:bg-amber-400 disabled:opacity-60"
          >
            {caricamento ? <Loader2 size={17} className="animate-spin" /> : <Lock size={16} />}
            {caricamento ? "Accesso in corso…" : "Accedi"}
          </button>
        </form>
        <p className="mt-6 text-center">
          <Link to="/" className="text-xs text-slate-500 transition-colors hover:text-amber-400" data-testid="admin-login-torna-home">
            ← Torna al sito
          </Link>
        </p>
      </div>
    </div>
  );
}
